import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AngularPlugin } from "@microsoft/applicationinsights-angularplugin-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AppInsightsService {
  private appInsights: ApplicationInsights | undefined;

  constructor(private router: Router) {
    if (
      environment.appInsightsConfig.connectionString !== undefined &&
      !environment.appInsightsConfig.connectionString?.startsWith("#{")
    ) {
      const maxBatchInterval = isNaN(Number(environment.appInsightsConfig.maxBatchIntervalMs))
        ? undefined
        : Number(environment.appInsightsConfig.maxBatchIntervalMs);
      console.log(maxBatchInterval);

      const angularPlugin = new AngularPlugin();
      this.appInsights = new ApplicationInsights({
        config: {
          enableDebug: environment.production === false,
          connectionString: environment.appInsightsConfig.connectionString,
          maxBatchInterval: maxBatchInterval,
          extensions: [angularPlugin],
          extensionConfig: {
            [angularPlugin.identifier]: { router: this.router },
          },
        },
      });
      this.appInsights.loadAppInsights();
    }
  }

  startMonitoring() {
    if (this.appInsights === undefined) return;

    this.router.events.subscribe({
      next: event => {
        if (event instanceof NavigationEnd) {
          this.appInsights!.trackPageView({
            name: event.urlAfterRedirects,
            uri: event.url,
          });
        }
      },
      error: error => {
        this.appInsights!.trackException({ exception: error });
      },
    });
  }

  trackEvent(name: string, properties?: Record<string, any>) {
    if (this.appInsights === undefined) return;

    this.appInsights.trackEvent({ name: name, properties: properties });
  }

  trackTrace(name: string, properties?: Record<string, any>) {
    if (this.appInsights === undefined) return;

    this.appInsights.trackEvent({ name: name, properties: properties });
  }
}
